const ContactHero = () => {
  return (
    <div className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/576ca72ae142cb4d0b6984fd780672a0.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-violet-900/90 via-purple-800/85 to-indigo-900/90"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="inline-block mb-6">
          <span className="px-4 py-2 bg-violet-500/20 border border-violet-400/30 rounded-full text-violet-200 text-sm font-semibold">
            Get In Touch
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Let's Build Your IT Foundation Together
        </h1>
        <p className="text-xl text-violet-100 max-w-2xl mx-auto leading-relaxed">
          Ready to transform your business with smart IT solutions? Our team is here to help you succeed.
        </p>
      </div>
    </div>
  );
};

export default ContactHero;